import { createSelector } from 'reselect';
import Immutable from 'immutable';

const getTransactions = state => state.getIn(['ugc', 'flagsTransactions'], Immutable.Map());

export const selectFlagsTransactions = createSelector([getTransactions], transactions => transactions);

export default {
  selectFlagsTransactions
};
